<form class="col-md-12">
    <div class="form-group">
        <label class="input-label">Change "{{previewTranslation.language}}" Translation for
      "{{previewTranslation.key}}"</label>
        <input class="form-control"
               value="{{previewTranslation.value}}"
               [(ngModel)]="previewTranslation.value"
               name="previewTranslation.value"
               type="text">
    </div>
    <primary-text-button [noLeftPadding]="true"
                         (click)="saveTranslation($event);">{{'Save' | translate}}</primary-text-button>
    <cancelary-text-button (click)="modalClosedWithoutReloadEvent.emit();">{{'Close window' | translate}}</cancelary-text-button>
</form>